import axios from "axios";
import React, { useEffect, useState } from "react";
import { Col, Label, Row } from "reactstrap";
import paginationFactory, {
	PaginationProvider,
} from "react-bootstrap-table2-paginator";
import { useHistory } from "react-router-dom";
import { Table } from "../../../components/CustomPaginations";
import {
	dateCol,
	statusColor,
	tableStyle,
} from "../../../components/TableStyle";
import { UserConsumer } from "../../../UserContext";
import { LeaveManagmentAPIs } from "../LeaveManagmentAPIs";
import DonutChartContainer from "../common/DonutChartContainer";
import "./manageLeavesStyle.scss";
import Header from "../../../components/Header";
import SubHeader from "../../../components/SubHeader";
import CustomReactSelect from "../../../components/CustomReactSelect";
import {
	GlobalPaginationSize,
	getPaginationSizeOnRole,
} from "../../../components/GlobalPaginationSize";
import { Routes } from "../../../configurations/config";
import LeaveActionComponent from "./LeaveActionComponent";

function ManageLeavesView() {
	let token = null;
	let empDesignation = null;
	const history = useHistory();
	const defaultSorted = [
		{
			dataField: "leaveAppliedDate",
			order: "desc",
		},
	];
	const [apiTokenHeader, setApiTokenHeader] = useState(null);
	const [leavesData, setLeavesData] = useState([]);
	const [pageNum, setPageNum] = useState(1);
	const [isLoading, setIsLoading] = useState(true);
	const [numberOfItemsPerPage, setNumberOfItemsPerPage] = useState(
		GlobalPaginationSize.defaultPaginationSize
	);
	const [pagerData, setPagerData] = useState(null);
	const [leavesQuotaResponse, setLeavesQuotaRespone] = useState(null);
	const [leaveStatusTypes, setLeaveStatusTypes] = useState(null);
	const [selectedStatus, setSelectedStatus] = useState(null);
	const [sortBy, setSortBy] = useState(defaultSorted[0]);

	const getColumns = [
		{
			dataField: "leaveAppliedDate",
			text: "Application Date",
			formatter: dateCol,
			sort: true,
		},
		{
			dataField: "leaveType",
			text: "Leave Type",
			sort: true,
		},
		{
			dataField: "leaveStartDate",
			text: "Start Date",
			sort: true,
			formatter: dateCol,
		},
		{
			dataField: "leaveDuration",
			text: "Leave Duration",
			sort: true,
		},
		{
			dataField: "supervisorStatus",
			text: "Supervisor Status",
			sort: true,
			formatter: getFormattedStatus,
			style: statusColor,
		},
		{
			dataField: "adminStatus",
			text: "Admin Status",
			sort: true,
			formatter: getFormattedStatus,
			style: statusColor,
		},
		{
			dataField: "action",
			text: "Action",
			formatter: (cell, row) => customFormatter(row),
		},
	];

	useEffect(() => {
		const pageSize = getPaginationSizeOnRole(empDesignation);
		setNumberOfItemsPerPage(pageSize);

		const header = {
			Authorization: `Bearer ${token}`,
		};

		axios
			.get(`${LeaveManagmentAPIs.GetLeaveStatusTypes}`, {
				headers: header,
			})
			.then(({ status, data }) => {
				if (status === 200) {
					const statusList = data.statusTypes;
					statusList.unshift({ value: 0, label: "All" });

					if (sessionStorage.getItem("MyLeavesFilter"))
						setSelectedStatus(
							JSON.parse(sessionStorage.getItem("MyLeavesFilter"))
						);
					else setSelectedStatus({ value: 0, label: "All" });

					delete statusList[4];
					statusList.sort((a, b) => a.label.localeCompare(b.label));
					setLeaveStatusTypes(statusList);
				}
			});

		axios
			.get(
				`${
					LeaveManagmentAPIs.GetDefaultLeaveApplication
				}PageNumber=${pageNum}&PageSize=${pageSize}&LeaveStatus=${
					sessionStorage.getItem("MyLeavesFilter")
						? JSON.parse(sessionStorage.getItem("MyLeavesFilter"))
								.value
						: 0
				}&SortBy=${sortBy.dataField}_${sortBy.order}`,
				{
					headers: header,
				}
			)
			.then((res) => {
				if (res.status === 200) {
					setIsLoading(false);
					setPagerData(JSON.parse(res.headers["x-pagination"]));
					setLeavesData(res.data.leaveDetails);
				}
			});
		async function fetchLeavesQuota() {
			const response = await axios.get(
				`${LeaveManagmentAPIs.GetLeavesQuota}`,
				{
					headers: header,
				}
			);
			if (response.data) {
				if (response.data.specialLeave.total === null) {
					setLeavesQuotaRespone({
						...response.data,
						["specialLeave"]: {
							...response.data["specialLeave"],
							total: 0,
						},
					});
				} else setLeavesQuotaRespone(response.data);
			}
		}
		fetchLeavesQuota();
		setApiTokenHeader(header);
	}, []);

	const customFormatter = (row) => (
		<LeaveActionComponent
			leaveApplicationId={row.leaveApplicationId}
			supervisorStatus={row.supervisorStatus}
		/>
	);
	function getFormattedStatus(status) {
		if (status === "Pending") {
			return "Pending";
		} else if (status === "InProgress") {
			return "In Progress";
		} else if (status === "Approved") {
			return "Approved";
		} else if (status === "Rejected") {
			return "Rejected";
		} else {
			return "Unknown";
		}
	}
	const leaveStatusHanlder = (obj) => {
		setSelectedStatus(obj);
		sessionStorage.setItem("MyLeavesFilter", JSON.stringify(obj));

		setIsLoading(true);
		axios
			.get(
				`${LeaveManagmentAPIs.GetLeavesbyPagination}PageSize=${numberOfItemsPerPage}&PageNumber=1&LeaveStatus=${obj.value}&SortBy=${sortBy.dataField}_${sortBy.order}`,
				{ headers: apiTokenHeader }
			)
			.then((res) => {
				if (res.status === 200) {
					setIsLoading(false);
					setPageNum(1);
					setPagerData(JSON.parse(res.headers["x-pagination"]));
					setLeavesData(res.data.leaveDetails);
				}
			});
	};

	const receiveData = (PageSize) => {
		setIsLoading(true);

		axios
			.get(
				`${LeaveManagmentAPIs.GetLeavesbyPagination}LeaveStatus=${
					sessionStorage.getItem("MyLeavesFilter")
						? JSON.parse(sessionStorage.getItem("MyLeavesFilter"))
								.value
						: selectedStatus.value
				}&PageNumber=1&PageSize=${PageSize}&SortBy=${
					sortBy.dataField
				}_${sortBy.order}`,
				{
					headers: apiTokenHeader,
				}
			)
			.then((res) => {
				if (res.status === 200) {
					setIsLoading(false);
					setPageNum(1);
					setNumberOfItemsPerPage(PageSize);
					setPagerData(JSON.parse(res.headers["x-pagination"]));
					setLeavesData(res.data.leaveDetails);
				}
			});
	};

	const handleTableChange = (type, { page, sortOrder, sortField }) => {
		setIsLoading(true);
		let getData = false;
		let apiURL = "";
		if (type === "sort") {
			apiURL = `${LeaveManagmentAPIs.GetLeavesbyPagination}LeaveStatus=${
				sessionStorage.getItem("MyLeavesFilter")
					? JSON.parse(sessionStorage.getItem("MyLeavesFilter")).value
					: selectedStatus?.value
			}&PageNumber=${page}&PageSize=${numberOfItemsPerPage}&SortBy=${sortField}_${sortOrder}`;
			setSortBy({ dataField: sortField, order: sortOrder });
			getData = true;
		} else if (type === "pagination") {
			apiURL = `${LeaveManagmentAPIs.GetLeavesbyPagination}LeaveStatus=${
				sessionStorage.getItem("MyLeavesFilter")
					? JSON.parse(sessionStorage.getItem("MyLeavesFilter")).value
					: selectedStatus?.value
			}&PageNumber=${page}&PageSize=${numberOfItemsPerPage}&SortBy=${
				sortBy.dataField
			}_${sortBy.order}`;
			getData = true;
		}
		if (getData) {
			axios
				.get(apiURL, {
					headers: apiTokenHeader,
				})
				.then((res) => {
					if (res.status === 200) {
						setIsLoading(false);
						setPageNum(page);
						setPagerData(JSON.parse(res.headers["x-pagination"]));
						setLeavesData(res.data.leaveDetails);
					}
				});
		}
	};
	const rowEvents = {
		onClick: (e, row) => {
			history.push({
				pathname: `${Routes.LeaveDetail}/${row.leaveApplicationId}`,
				state: {
					status: row.supervisorStatus,
				},
			});
		},
	};
	return (
		<UserConsumer>
			{(userDetails) => {
				token = userDetails.token;
				empDesignation = userDetails.designation;
				return (
					<>
						<div className="container-fluid pl-3 pr-3">
							<Header
								title="Leave Management"
								headerBorder={true}
							/>

							<SubHeader
								title="My Leave Quota"
								btnTitle="Request Leave"
								linkTo={Routes.CreateLeave}
							/>

							{leavesQuotaResponse ? (
								<DonutChartContainer
									leavesQuotaResponse={leavesQuotaResponse}
								/>
							) : null}

							<Row>
								<div className="col col-xxl-8 col-xl-6 col-lg-8 col-md-8 col-sm-6 col-xs-6 my-3 d-flex align-items-baseline">
									<Label className="labelText">
										Filter Applications By
									</Label>
									<Col sm={4} md={6} lg={4}>
										<CustomReactSelect
											options={leaveStatusTypes}
											value={selectedStatus}
											onChange={(value) =>
												leaveStatusHanlder(value)
											}
											paginationDropDown={true}
										/>
									</Col>
								</div>
							</Row>

							{pagerData ? (
								<PaginationProvider
									pagination={paginationFactory({
										custom: true,
										totalSize: leavesData.length,
										page: pagerData.CurrentPage,
										sizePerPage: pagerData.PageSize,
										paginationSize: pagerData.PageSize,
									})}
								>
									{({
										paginationProps,
										paginationTableProps,
									}) => {
										return (
											<Table
												inputValue={""}
												keyField={"id"}
												columns={getColumns}
												items={leavesData}
												tableStyle={tableStyle}
												paginationProps={
													paginationProps
												}
												paginationTableProps={
													paginationTableProps
												}
												onTablePageChange={
													handleTableChange
												}
												defaultSorted={defaultSorted}
												showFeedback={false}
												tableLoader={isLoading}
												SearchBar={() => {
													return null;
												}}
												pagerData={pagerData}
												receiveData={(PageSize) => {
													receiveData(PageSize);
												}}
												rowEvents={rowEvents}
											/>
										);
									}}
								</PaginationProvider>
							) : null}
						</div>
					</>
				);
			}}
		</UserConsumer>
	);
}

export default ManageLeavesView;
